import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { bem } from 'helpers/class-name';
import Segment from 'helpers/segment';
import Message from 'components/Message';
import { Card, CardTitle } from 'components/Card';
import { openModal } from 'components/Modal';
import { selectActiveVenueId } from 'selectors/general';
import { selectIsMobile } from 'selectors/ui';

import { makePanelId, makeTabId, TOPIC_SEGMENT_NAME, TOPICS } from './HowSmartRateWorks.constants';
import messages from './HowSmartRateWorks.messages';
import SmartRateTopicCard from './SmartRateTopicCard';
import SmartRateTopicPanel from './SmartRateTopicPanel';
import { SMART_RATE_HOW_IT_WORKS_MODAL_NAME } from './SmartRateHowItWorksModal';
import './HowSmartRateWorks.scss';

const { block, element } = bem('how-smart-rate-works');

const HowSmartRateWorks = () => {
  const dispatch = useDispatch();
  const [selectedTopicId, setSelectedTopicId] = useState(null);
  const isMobile = useSelector(selectIsMobile);
  const venueId = useSelector(selectActiveVenueId);

  const handleTopicSelect = topicId => {
    Segment.event('Click SmartRate Tile', {
      tile_name: TOPIC_SEGMENT_NAME[topicId],
      venue_id: venueId,
    });

    if (isMobile) {
      dispatch(openModal(SMART_RATE_HOW_IT_WORKS_MODAL_NAME, { topicId }));
      return;
    }
    setSelectedTopicId(prev => (prev === topicId ? null : topicId));
  };

  const handlePanelClose = () => {
    setSelectedTopicId(null);
  };

  const sectionBody = (
    <>
      <Message as={CardTitle} message={messages.sectionTitle} />
      <div className={element('topics')} role="tablist">
        {TOPICS.map(topic => (
          <SmartRateTopicCard
            key={topic.id}
            description={topic.description}
            icon={topic.icon}
            isSelected={!isMobile && selectedTopicId === topic.id}
            onSelect={handleTopicSelect}
            panelId={makePanelId(topic.id)}
            showLess={messages.showLess}
            showMore={messages.showMore}
            tabId={makeTabId(topic.id)}
            title={topic.title}
            topicId={topic.id}
          />
        ))}
      </div>
      {!isMobile && (
        <SmartRateTopicPanel
          isOpen={Boolean(selectedTopicId)}
          labelledBy={selectedTopicId ? makeTabId(selectedTopicId) : undefined}
          onClose={handlePanelClose}
          topicId={selectedTopicId}
        />
      )}
    </>
  );

  if (isMobile) {
    return <div className={block()}>{sectionBody}</div>;
  }

  return <Card className={block()}>{sectionBody}</Card>;
};

export default HowSmartRateWorks;
